/**
 * WordPress dependencies
 */
import domReady from '@wordpress/dom-ready';
// eslint-disable-next-line import/no-unresolved
import jQuery from 'jquery';

const toggleMegaMenuState = (megaMenuLinkItem, megaMenu) => {
	const caret = megaMenuLinkItem.querySelector('.caret.icon');
	const caretDown = caret.classList.contains('down');
	megaMenuLinkItem.classList.toggle('active');
	if (caretDown) {
		caret.classList.add('up');
		caret.classList.remove('down');
	} else {
		caret.classList.add('down');
		caret.classList.remove('up');
	}
	console.log(
		'toggleMegaMenuState',
		megaMenuLinkItem,
		megaMenu,
		caret,
		caretDown,
	);
	jQuery(megaMenu).transition('fade');
};

const watchOutsideHandler = (event) => {
	const megaMenuItem = document.getElementById('js-desktop-mega-menu-trigger');
	const megaMenu = document.getElementById('desktop-mega-menu');
	console.log('Document click with active menu... click:', event.target);
	if (
		!megaMenuItem.contains(event.target) &&
		!megaMenu.contains(event.target)
	) {
		toggleMegaMenuState(megaMenuItem, megaMenu);
	}
};

// a function that will watch for when the esc key is pressed and then console.logs out the event.
const escKeyHandler = (event) => {
	if ('Escape' === event.key) {
		const megaMenuItem = document.getElementById(
			'js-desktop-mega-menu-trigger',
		);
		const megaMenu = document.getElementById('desktop-mega-menu');
		toggleMegaMenuState(megaMenuItem, megaMenu);
	}
};

const megaMenuClickHandler = (link, menu) => {
	const megaMenuCloseIcon = menu.querySelector('.close.icon');
	link.addEventListener('click', () => {
		toggleMegaMenuState(link, menu);
	});
	if (megaMenuCloseIcon) {
		megaMenuCloseIcon.addEventListener('click', () => {
			toggleMegaMenuState(link, menu);
		});
	}

	// need a new mutation observer to watch for changes to the mega menu, watch for an "active" class and if it's added, watch for clicks outside of the menu, if its removed then remove the event listener.
	const megaMenuObserver = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if ('class' === mutation.attributeName) {
				const megaMenuItemTrigger = mutation.target.classList;
				console.log('Observer change: ', megaMenuItemTrigger);
				if (megaMenuItemTrigger.contains('active')) {
					document.addEventListener('click', watchOutsideHandler);
					document.addEventListener('keydown', escKeyHandler);
				} else {
					document.removeEventListener('click', watchOutsideHandler);
					document.removeEventListener('keydown', escKeyHandler);
				}
			}
		});
	});

	megaMenuObserver.observe(link, {
		attributes: true,
	});
};

const desktopMastheadHandler = () => {
	const megaMenuItem = document.getElementById('js-desktop-mega-menu-trigger');
	const megaMenu = document.getElementById('desktop-mega-menu');
	megaMenuClickHandler(megaMenuItem, megaMenu);
};

const mobileMastheadHandler = () => {
	const defaultSidebarArgs = {
		context: document.querySelector('.pushable'),
		exclusive: true,
		dimPage: true,
		scrollLock: true,
		onChange: () => {
			const pushable = document.querySelector('.pushable');
			pushable.classList.toggle('active');
		},
	};

	jQuery('#mobile-nav')
		.sidebar({ ...defaultSidebarArgs })
		.sidebar('attach events', '#js-mobile-nav-trigger');

	const megaMenuItem = document.getElementById('js-mobile-mega-menu-trigger');
	const megaMenu = document.getElementById('mobile-mega-menu');
	const accordion = megaMenu.querySelector('.ui.accordion');
	jQuery(accordion).accordion();
	megaMenuClickHandler(megaMenuItem, megaMenu);

	jQuery('#mobile-search')
		.sidebar({ ...defaultSidebarArgs })
		.sidebar('setting', 'transition', 'overlay')
		.sidebar('attach events', '#js-mobile-search-trigger');
};

function jobOpeningHandler() {
	console.warn(
		`We're looking for a junior developer to join our team in Washington, D.C!`,
		'\n',
		`If you're interested in a career where React, WordPress, and data driven journalism intersect check out:`,
		'\n',
		'https://pewresearch.org/web-developer',
	);
}

domReady(() => {
	desktopMastheadHandler();
	mobileMastheadHandler();
});
